const style = (theme) => {
  const output = {
    root: {
      minHeight: '100vh',
    },
    wrap: {
      extend: theme.wrapper,
      position: 'relative',
    },
    heroContainer: {
      position: 'relative',
    },
    hero: {
      color: theme.colors[1],
    },
    heroFooter: {
      position: 'absolute',
      bottom: 0,
      padding: '0 7vw 30px 7vw',
      width: '100%',
      textTransform: 'uppercase',
      color: theme.colors[1],
      fontWeight: 300,
      fontSize: 20,
      display: 'flex',
      alignItems: 'flex-end',
    },
    heroText: {
      width: '40%',
      fontSize: 16,
      textTransform: 'none',
      '& p': {
        width: '68%',
        margin: 0,
      },
    },
    heroLabels: {
      width: '30%',
    },
    products: {
      marginTop: 150,
      marginBottom: 150,
    },
    productView: {
      display: 'flex',
      flexFlow: 'row wrap',
      justifyContent: 'flex-start',
      marginLeft: -30,
      marginRight: -30,
      '& .productItem__root': {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: 58,
        width: 'calc(100% / 3)',
        padding: '0 30px',
      },
      '& .productItem__image': {
        paddingBottom: '100%',
      },
      '& .productItem__desc': {
        paddingTop: 20,
      },
    },
    heading: {
      position: 'relative',
      '& .borderedTitle__root': {
        zIndex: 1,
      },
    },
  }

  /*------------------------------
  LG
  ------------------------------*/
  output[theme.mediaInverse.xl] = {
    productView: {
      flex: '1 1 100%',
      marginLeft: -20,
      marginRight: -20,
      '& .productItem__root': {
        width: 'calc(100% / 3)',
        padding: '0 20px',
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    products: {
      marginTop: 50,
    },
    productView: {
      marginLeft: -10,
      marginRight: -10,
      '& .productItem__root': {
        width: 'calc(100% / 2)',
        marginBottom: 25,
        padding: 10,
      },
    },
    heroFooter: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    heroLabels: {
      width: '100%',
      marginBottom: 10,
    },
    heroText: {
      padding: '20px 7vw',
      width: '100%',
      '& p': {
        width: '100%',
      },
    },
  }

  return output
}

export default style
